module.exports = __webpack_public_path__ + "static/media/icon-calendar.67e25a39.svg";